import { render, staticRenderFns } from "./BadgeIcon.vue?vue&type=template&id=135f7565"
import script from "./BadgeIcon.vue?vue&type=script&lang=js"
export * from "./BadgeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports